import React from 'react';
import { SearchEngineStyles, TopicStyles } from '../mixins/mixins';
import { StyleDropdownMenu } from '../components/common';
import {
	SearchBarOptionsValues,
	SearchBarStyleValues
} from '../mixins/optionsValues';
import { SearchEngineStyle } from './searchEngineStyle';
import { GreetingStyle } from './greetingStyle';
import { MyFocusStyle } from './myFocusStyle ';

export const SearchBarStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	const addSearchEngine = () => {
		const newSearchEngines = style.searchEngines;
		newSearchEngines.push({
			searchEngine: 'google',
			type: SearchBarStyleValues.ROUNDED,
			colored: true,
			openNewTab: true,
			border: true,
			size: 35
		});

		setStyle({
			...style,
			searchEngines: newSearchEngines
		});
	};

	return (
		<>
			<div className="flex flex-row px-10">
				<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4 w-10/12">
					<StyleDropdownMenu
						key="searchbarOptions"
						name={'Searchbar Options'}
						options={[
							{ name: 'Searchbar', value: SearchBarOptionsValues.SEARCHBAR },
							{ name: 'My Focus', value: SearchBarOptionsValues.MYFOCUS },
							{ name: 'Greetings', value: SearchBarOptionsValues.GREETING }
						]}
						optionState={style.searchbarOptions}
						handleChange={(value: any) => {
							setStyle({ ...style, searchbarOptions: value });
						}}
					/>
				</div>
			</div>

			{style.searchbarOptions === SearchBarOptionsValues.SEARCHBAR ? (
				<>
					<div className="flex flex-row">
						<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
							Search Engines
						</h3>
						<div className="flex flex-1 justify-end">
							<button
								className="btn btn-outline btn-sm btn-primary ml-auto mt-1 mr-8"
								onClick={(e) => {
									e.preventDefault();
									addSearchEngine();
								}}
							>
								Add ➕
							</button>
						</div>
					</div>
					{style.searchEngines.map((item: SearchEngineStyles, index) => (
						<div>
							<SearchEngineStyle
								key={item.searchEngine + index}
								item={item}
								index={index}
								style={style}
								setStyle={setStyle}
							/>
						</div>
					))}
				</>
			) : style.searchbarOptions === SearchBarOptionsValues.GREETING ? (
				<GreetingStyle key={'greetings'} style={style} setStyle={setStyle} />
			) : (
				<MyFocusStyle key={'greetings'} style={style} setStyle={setStyle} />
			)}
		</>
	);
};
